import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../lib/utils';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}
// Simple utility for class names if not already present
function classNames(...classes: (string | undefined | null | false)[]) {
  return classes.filter(Boolean).join(' ');
}
export function Button({
  children,
  className,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-terracotta-500 text-white hover:bg-terracotta-600 shadow-lg hover:shadow-xl focus:ring-terracotta-500',
    secondary: 'bg-cream-100 text-brown-800 hover:bg-cream-200 focus:ring-cream-200',
    outline: 'border-2 border-terracotta-500 text-terracotta-500 hover:bg-terracotta-50 focus:ring-terracotta-500'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={classNames(baseStyles, variants[variant], sizes[size], fullWidth ? 'w-full' : '', className)} {...props} data-id="element-183">
      {children}
    </motion.button>;
}